/**
 * EL TELÉFONO Y EL CORREO QUE SE ESCRIBEN A MANO, CON FORMA (ALT-10, 14-10).
 *
 * La misma regla que aplica el servidor (`es_un_telefono` y `es_un_correo` en
 * `backend/core/alta.py`), para que la pantalla lo diga al escribirlo y no al guardar. Pedir
 * la llamada ya exigía 9 cifras; el cuestionario del alta, que pide «un whatsapp de
 * contacto», solo miraba que el campo no estuviera vacío y daba por bueno «abc».
 */

/** De 9 a 15 cifras, se escriban como se escriban («600 11 22 33», «+34 600-112-233»). */
export const esUnTelefono = (valor) => {
    const cifras = String(valor ?? '').replace(/\D/g, '').length;
    return cifras >= 9 && cifras <= 15;
};

/** Algo, una arroba, algo, un punto y algo. El servidor es quien lo mira a fondo. */
export const esUnCorreo = (valor) => /^\S+@\S+\.\S+$/.test(String(valor ?? '').trim());

export const TELEFONO_QUE_NO_VALE = 'Escríbelo entero, con sus 9 cifras.';
export const CORREO_QUE_NO_VALE = 'Ese correo no parece válido.';
